import React from 'react';
import { Typography } from '@material-ui/core';
import Form from './Form';
import PageContentArea from '../step/PageContentArea';

const Page: React.FC = () => {
    return (
        <PageContentArea>
            <div style={{ textAlign: 'center' }}>
                <Typography variant='h1' color='textPrimary'>Los geht‘s!</Typography>
                <Typography variant='h6' color='textPrimary' style={{ marginTop: 10 }}>Beschreiben Sie uns kurz Ihre tierische Situation, damit wir Ihnen das passende Angebot erstellen können.</Typography>
            </div>

            <Form />

        </PageContentArea>

    );
}

export default Page;